import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "providers/auth";
import { usePatternBackground } from "providers/pattern-background";
import { useTranslation } from "lib/i18n/use-translation";
import { OriAvatar } from "components/ori";
import { trackEvent } from "utility/mixpanel";
import { OnboardingLoader } from "./onboarding-loader";
import styles from "../ori-intro.module.scss";

const BONE_100 = "#f4efea";

const OriIntro: React.FC = () => {
  const { learner, loading } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation(["onboard", "common"]);
  const { onChangeColors } = usePatternBackground();
  const hasLearner = Boolean(learner?.onboarding);

  useEffect(() => {
    onChangeColors(null, false, BONE_100, false);
    trackEvent("Onboarding Started");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading || !hasLearner) {
    return <OnboardingLoader />;
  }

  return (
    <div className={styles["screen"]} data-testid="onboarding-ori-intro">
      <div className={styles["content"]}>
        <div className={styles["orb"]}>
          <OriAvatar size={220} />
        </div>
        <div className={styles["textColumn"]}>
          <h1 className={styles["heading"]}>{t("onboard:welcome.heading")}</h1>
          <p className={styles["body"]}>
            {`${t("onboard:welcome.introLine1")}\n\n${t(
              "onboard:welcome.introLine2",
            )}`}
          </p>
          <button
            type="button"
            className={styles["continueButton"]}
            onClick={() => {
              trackEvent("Onboarding Ori Intro Continue Tapped");
              navigate("/user/onboard/wone-profile");
            }}
            data-testid="onboard-ori-intro-continue"
          >
            {t("common:action.continue")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OriIntro;
